import React, { useState, useContext } from "react";
import Contexto from "../context/Contexto";

import "../assets/css/Registro.css";
import { Link } from "react-router-dom";

const Registro = (props) => {
  const {
    productos,
    seteos,
    usuario,
    loginUsuarioConEmail,
    crearUsuarioConEmail,
  } = useContext(Contexto);

  const [registrar, setRegistrar] = useState(false);
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [emailReg, setEmailReg] = useState("");
  const [passReg, setPassReg] = useState("");
  const [registrando, setRegistrando] = useState(false);
  let registro = [];
  const { onLogin } = props;

  const handleChange = (p) => {
    if (p.target.name == "password") {
      setPass(p.target.value);
    }
    if (p.target.name == "email") {
      setEmail(p.target.value);
    }
    if (p.target.name == "passwordReg") {
      setPassReg(p.target.value);
    }
    if (p.target.name == "emailReg") {
      setEmailReg(p.target.value);
    }
  };

  const handleClick = () => {
    loginUsuarioConEmail(email, pass);
    console.log("quiere entrar->", email, pass);
  };

  const registrate = () => {
    if (registrando) {
      crearUsuarioConEmail(emailReg, passReg);
    } else {
      setRegistrando(!registrando);
    }
  };

  return (
    <React.Fragment>
      <p className="titFelicitaciones">¡HOLA!</p>
      <>
        <input
          type="email"
          name="email"
          onChange={handleChange}
          placeholder="tu email"
          className="formuCC"
          autoComplete="new-email"
        />

        <input
          type="password"
          name="password"
          onChange={handleChange}
          placeholder="tu contraseña"
          className="formuCC"
          autoComplete="new-password"
        />

        <button
          id="registro"
          className="formuBT"
          name="registrar"
          onClick={handleClick}
        >
          acceder
        </button>
        <p className="aclaracion">
          Para Design Season necesitás crear y usar una nueva cuenta y
          contraseña (no es la de Color Club ni la de Codea Rock). A este email
          que elijas te van a llegar todos los correos del programa. No olvides
          revisar Spam y Promociones.
        </p>
        <p>Si no tienes cuenta:</p>
        {registrando && (
          <>
            <input
              type="email"
              name="emailReg"
              onChange={handleChange}
              placeholder="Registrá tu email"
              className="formuCC"
            />

            <input
              ///
              type="password"
              name="passwordReg"
              onChange={handleChange}
              placeholder="Registrá tu contraseña"
              className="formuCC"
            />
          </>
        )}
        <button
          id="registro"
          className="formuBT"
          name="acceder"
          onClick={registrate}
        >
          crear cuenta
        </button>
        <br />
      </>

      <p>
        <Link className="botonito manito formuBTLiner " to="/restablecer">
          CAMBIAR CONTRASEÑA
        </Link>
      </p>
    </React.Fragment>
  );
};

export default Registro;
